import { CheckCircleOutlined } from "@ant-design/icons";
import { Tag } from "antd";

type ReportDoneBadgeProps = {
  reportDone: boolean | null | undefined;
};

export const ReportDoneBadge = ({ reportDone }: ReportDoneBadgeProps) => {
  if (reportDone) {
    return (
      <Tag color="success" icon={<CheckCircleOutlined />}>
        Report Sent
      </Tag>
    );
  }
  return <Tag>Report Not Sent</Tag>;
};
